const rollOptions = {
  "duration":   500,
  "delay": 0,
  "direction":  "left"
};

// -----
const delay = ms => new Promise(fn => setTimeout(fn, ms));

const toggle = (event, id) => {
	const $img = $w(id);
	const type = event.type;

	if ($img.hidden && type === 'mouseleave') {
		delay(1000).then(() => $img.hide("roll", rollOptions));
		return;
	}

  	if ($img.isVisible && type === 'mouseenter') {
		return;
	}

  	if (type === 'mouseenter') {
		$img.show("roll", rollOptions);
	}

	if (type === 'mouseleave') {
		$img.hide("roll", rollOptions);
	}
};

// ----

$w.onReady(function () {});

export function text20_mouseIn(event, $w) {
	toggle(event, '#image1');
}

export function text20_mouseOut(event, $w) {
	toggle(event, '#image1');
}

export function text19_mouseIn(event, $w) {
  toggle(event, '#image2');
}

export function text19_mouseOut(event, $w) {
  toggle(event, '#image2');
}

export function text18_mouseIn(event, $w) {
  toggle(event, '#image3');
}

export function text18_mouseOut(event, $w) {
  toggle(event, '#image3');
}

export function text17_mouseIn(event, $w) {
  toggle(event, '#image4');
}

export function text17_mouseOut(event, $w) {
  toggle(event, '#image4');
}

export function text16_mouseIn(event, $w) {
  toggle(event, '#image5');
}

export function text16_mouseOut(event, $w) {
  toggle(event, '#image5');
}

export function text15_mouseIn(event, $w) {
  toggle(event, '#image6');
}

export function text15_mouseOut(event, $w) {
  toggle(event, '#image6');
}

export function text13_mouseIn(event, $w) {
  toggle(event, '#image14');
}

export function text13_mouseOut(event, $w) {
  toggle(event, '#image14');
}

export function text12_mouseIn(event, $w) {
  toggle(event, '#image13');
}

export function text12_mouseOut(event, $w) {
  toggle(event, '#image13');
}

export function text11_mouseIn(event, $w) {
  toggle(event, '#image12');
}

export function text11_mouseOut(event, $w) {
  toggle(event, '#image12');
}

export function text10_mouseIn(event, $w) {
  toggle(event, '#image11');
}

export function text10_mouseOut(event, $w) {
  toggle(event, '#image11');
}

export function text9_mouseIn(event, $w) {
  toggle(event, '#image10');
}

export function text9_mouseOut(event, $w) {
  toggle(event, '#image10');
  }

export function text8_mouseIn(event, $w) {
  toggle(event, '#image8');
}

export function text8_mouseOut(event, $w) {
  toggle(event, '#image8');
}
